import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { 
  Home, 
  LayoutDashboard, 
  Grid,
  Shield,
  Stethoscope,
  UserCheck,
  Users,
  Globe,
  GraduationCap,
  MessageCircle,
  Newspaper
} from 'lucide-react';

const TopNavMenu = ({ currentPortal, onPortalChange }) => {
  const navigate = useNavigate();

  const portals = [
    { 
      id: 'internal', 
      name: 'Internal/Admin', 
      icon: <Shield className="h-5 w-5" />,
      path: '/dashboard',
      description: 'Admin controls and management'
    },
    { 
      id: 'providers', 
      name: 'Providers', 
      icon: <Stethoscope className="h-5 w-5" />,
      path: '/doctors',
      description: 'Provider network and referrals'
    },
    { 
      id: 'current-patients', 
      name: 'Current Patients', 
      icon: <UserCheck className="h-5 w-5" />,
      path: '/patients',
      description: 'Active patient management'
    },
    { 
      id: 'future-patients', 
      name: 'Future Patients', 
      icon: <Users className="h-5 w-5" />,
      path: '/referrals',
      description: 'Prospective and referred patients'
    },
    { 
      id: 'public', 
      name: 'Public', 
      icon: <Globe className="h-5 w-5" />,
      path: '/',
      description: 'Public-facing website'
    },
    { 
      id: 'education', 
      name: 'Education', 
      icon: <GraduationCap className="h-5 w-5" />,
      path: '/courses',
      description: 'Learning and training portal'
    },
    { 
      id: 'community', 
      name: 'Community', 
      icon: <MessageCircle className="h-5 w-5" />,
      path: '/community',
      description: 'Forums and discussions'
    },
    { 
      id: 'blog-news', 
      name: 'Blog & News', 
      icon: <Newspaper className="h-5 w-5" />,
      path: '/blog',
      description: 'Latest updates and articles'
    }
  ];

  const handlePortalSelect = (portal) => {
    if (onPortalChange) {
      onPortalChange(portal.id);
    }
    navigate(portal.path);
  };

  return (
    <div className="flex items-center space-x-2 bg-white border-b border-gray-200 px-4 py-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => navigate('/')}
        className="flex items-center space-x-2"
      >
        <Home className="h-4 w-4" />
        <span>Home</span>
      </Button>

      <Button
        variant="ghost"
        size="sm"
        onClick={() => navigate('/dashboard')}
        className="flex items-center space-x-2"
      >
        <LayoutDashboard className="h-4 w-4" />
        <span>Dashboard</span>
      </Button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="flex items-center space-x-2">
            <Grid className="h-4 w-4" />
            <span>Portal Picker</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-72">
          <div className="px-2 py-2">
            <p className="text-xs font-semibold text-gray-500 uppercase mb-2">Select Portal</p>
          </div>
          <DropdownMenuSeparator />
          {portals.map((portal) => (
            <DropdownMenuItem
              key={portal.id}
              onClick={() => handlePortalSelect(portal)}
              className="cursor-pointer"
            >
              <div className="flex items-start space-x-3 w-full">
                <div className="text-[#D4AF37] mt-1">{portal.icon}</div>
                <div className="flex-1">
                  <p className="font-semibold text-[#0A1628]">{portal.name}</p>
                  <p className="text-xs text-gray-600">{portal.description}</p>
                </div>
              </div>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default TopNavMenu;
